module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("This book")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("in which something most extraordinary happens")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("is about Brick and Diz Dobie and Lily Rose")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("and Charlie Pill and Princess")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('i', [_vm._v("and it is dedicated to all of you")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('i', [_vm._v("who understand them")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('i', [_vm._v("and feel as they did")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('i', [_vm._v("and have come to believe that")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('i', [_vm._v("practically anything is possible")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 60
// module chunks = 0